<script>

import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import DataTable from 'datatables.net-vue3';
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Aging Report",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Aging Report",
            items: [
                {
                text: "Aging Report",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            aging_listing:[],
            aging_summary_listing:[],
            loadingDetail:false,
            loadingRoles:true,
            date: '',
            dtKey:0,
            key_search:'',
            days_30: '0.00',
            days_60: '0.00',
            days_90: '0.00',
            days_120: '0.00',
            days_above_120: '0.00',        
            total_aging_outstanding: '0.00',        
        };
    },
  setup() {
        const {
            canCreateAgingReport,
            canReadAgingReport,
            canExportAgingReport
        } = usePermissions()
        return {
            canCreateAgingReport,
            canReadAgingReport,
            canExportAgingReport
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        formatCurrency(value) {
            let val = (value/1).toFixed(2)
            return "RM " +val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        getAgingSummaryById(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/agingSummaryById/'+this.$route.params.id)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.aging_summary_listing = response.data;
                    this.dtKey +=1;
                    this.days_30 = this.aging_summary_listing[0].days_0_30;
                    this.days_60 = this.aging_summary_listing[0].days_31_60;
                    this.days_90 = this.aging_summary_listing[0].days_61_90;
                    this.days_120 = this.aging_summary_listing[0].days_91_120;
                    this.days_above_120 = this.aging_summary_listing[0].more_than_120;
                    this.total_aging_outstanding = this.aging_summary_listing[0].total_aging_outstanding;

                    console.log(this.aging_summary_listing);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
    },

    components: {
        //flatPickr,
        DataTable,
    },

    mounted() {
        this.getAgingSummaryById();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card" v-if="canReadAgingReport">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false,searching: false, ordering: false, paging: false, info: false}" :key="dtKey" class="table table-striped table-nowrap mb-5" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>              
                                            
                                            <th scope="col">0 - 30 Days</th>
                                            <th scope="col">31 - 60 Days</th>
                                            <th scope="col">61 - 90 Days</th>           
                                            <th scope="col">91 - 120 Days</th>           
                                            <th scope="col">> 120 Days</th> 
                                            <th scope="col">Total Outstanding</th>          
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr class="content">
                                                                          
                                            <td>{{ formatCurrency(days_30) }}</td>
                                            <td>{{ formatCurrency(days_60) }}</td>
                                            <td>{{ formatCurrency(days_90) }}</td>                                      
                                            <td>{{ formatCurrency(days_120) }}</td>                              
                                            <td>{{ formatCurrency(days_above_120) }}</td> 
                                            <td>{{ formatCurrency(total_aging_outstanding) }}</td>                             
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center text-muted p-4">
            You do not have permission to view Aging.
     </div>
    </Layout>
</template>